/**
 * HomeGroupWA Super Sale Page JS Include
 *
 * @author Strange Animals <info@strangeanimals.com.au>
 */

window.SuperSalePageObject = function(opts) {
    var supersalepage_obj = $.extend(new PageObject({}), {
        setupSlick: function() {
            $('.supersale-carousel')
                .not('.slick-initialized')
                .slick({
                    dots: true,
                    prevArrow: false,
                    nextArrow: false,
                    swipe: true,
                    swipeToSlide: true,
                    slidesToShow: 1
                });

            $('.supersale-carousel').on('afterChange', function(event, slick, currentSlide) {
                $('#TotemForm_SuperSaleEnquiryForm_HomeDesignID').val($(slick.$slides.get(currentSlide)).data('id'));
            });

            $('.design-item').on('click', function(e) {
                var index = $(this).index();
                $('.supersale-carousel').slick('slickGoTo', index, false);
            });
        },

        //event handlers...
        onInit: function() {},
        onReady: function() {
            this.setupSlick();
        },
        onResize: function() {},
        onLoad: function() {}
    });

    if (opts) {
        return $.extend(supersalepage_obj, opts);
    } else {
        return supersalepage_obj;
    }
};
